"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLTableCaptionElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLTableCaptionElementImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/nodes/HTMLTableCaptionElement-impl.js
// module id = R7gS
// module chunks = 1